import { useEffect, useRef } from 'react';

export const useKey = (keyName: string, callback: () => void, enabled = true) => {
  const callbackRef = useRef(callback);

  useEffect(() => {
    callbackRef.current = callback;
  }, [callback]);

  useEffect(() => {
    if (!enabled) {
      return;
    }

    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key !== keyName || event.defaultPrevented || event.isComposing) {
        return;
      }

      event.preventDefault();
      callbackRef.current();
    };

    window.addEventListener('keydown', handleKeyDown);

    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [enabled, keyName]);
};
